import script from "./PrivacyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyModal.vue?vue&type=script&setup=true&lang=ts"

import "./PrivacyModal.vue?vue&type=style&index=0&id=8109cd44&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8109cd44"]])

export default __exports__